export const SportHandleList = {
  american_football: "american_football",
  american_footballLiteral: "Fútbol Americano",

  anticipadas: "anticipadas",
  anticipadasLiteral: "Anticipadas",

  Automovilismo: "Automovilismo",
  AutomovilismoLiteral: "Automovilismo",

  apuestas_anticipadas: "apuestas_anticipadas",
  apuestas_anticipadasLiteral: "Apuestas Anticipadas",

  apuestas_especiales: "apuestas_especiales",
  apuestas_especialesLiteral: "Apuestas Especiales",

  artes_marciales: "artes_marciales",
  artes_marcialesLiteral: "Artes Marciales",

  badminton: "badminton",
  badmintonLiteral: "Bádminton",

  baseball: "baseball",
  baseballLiteral: "Béisbol",

  basketball: "basketball",
  basketballLiteral: "Baloncesto",

  beach_soccer: "beach_soccer",
  beach_soccerLiteral: "Fútbol Playa",

  beach_volleyball: "beach_volleyball",
  beach_volleyballLiteral: "Voley Playa",

  billard: "billard",
  billardLiteral: "Billar",

  bowls: "bowls",
  bowlsLiteral: "Bolos",

  boxeo: "boxeo",
  boxeoLiteral: "Boxeo",

  boxing: "boxing",
  boxingLiteral: "Boxeo",

  cine: "cine",
  cineLiteral: "Cine",

  cycling: "cycling",
  cyclingLiteral: "Ciclismo",

  darts: "darts",
  dartsLiteral: "Dardos",

  ebasket: "ebasket",
  ebasketLiteral: "e-Basket",

  efootball: "efootball",
  efootballLiteral: "e-Fútbol",

  especiales: "especiales",
  especialesLiteral: "Especiales",

  esports: "esports",
  esportsLiteral: "eSports",

  eSports: "eSports",
  eSportsLiteral: "eSports",

  eSports_sports: "eSports_sports",
  eSports_sportsLiteral: "eFútbol",

  Esports_sports: "Esports_sports",
  Esports_sportsLiteral: "eFútbol",

  field_hockey: "field_hockey",
  field_hockeyLiteral: "Hockey hierba",

  Field_hockey: "Field_hockey",
  Field_hockeyLiteral: "Hockey hierba",

  futsal: "futsal",
  futsalLiteral: "Fútbol Sala",

  golf: "golf",
  golfLiteral: "Golf",

  greyhound_racing: "greyhound_racing",
  greyhound_racingLiteral: "Carreras de galgos",

  handball: "handball",
  handballLiteral: "Balonmano",

  horse_racing: "horse_racing",
  horse_racingLiteral: "Carreras de caballos",

  ice_hockey: "ice_hockey",
  ice_hockeyLiteral: "Hockey sobre hielo",

  loteria: "loteria",
  loteriaLiteral: "Lotería",

  loterias: "loterias",
  loteriasLiteral: "Loterías",

  mejora: "mejora",
  mejoraLiteral: "Mejora",

  mejora_la_linea: "mejora_la_linea",
  mejora_la_lineaLiteral: "Mejora la Línea",

  motor: "motor",
  motorLiteral: "Motor",

  motorsport: "motorsport",
  motorsportLiteral: "Motor",

  musica: "musica",
  musicaLiteral: "Música",

  olimpiada: "olimpiada",
  olimpiadaLiteral: "Olimpiada",

  olimpiadas: "olimpiadas",
  olimpiadasLiteral: "Olimpiadas",

  olyswi: "olyswi",
  olyswiLiteral: "Olimpiadas de Natación",

  padel: "padel",
  padelLiteral: "Pádel",

  pelota: "pelota",
  pelotaLiteral: "Pelota",

  politica: "politica",
  politicaLiteral: "Política",

  pool: "pool",
  poolLiteral: "Pool",

  rugby: "rugby",
  rugbyLiteral: "Rugby",

  rugby_league: "rugby_league",
  rugby_leagueLiteral: "Rugby League",

  rugby_union: "rugby_union",
  rugby_unionLiteral: "Rugby Union",

  snooker: "snooker",
  snookerLiteral: "Snooker",

  soccer: "soccer",
  soccerLiteral: "Fútbol",

  soccer_indoor: "soccer_indoor",
  soccer_indoorLiteral: "Fútbol Sala",

  special_bets: "special_bets",
  special_betsLiteral: "Special Bets",

  squash: "squash",
  squashLiteral: "Squash",

  swim: "swim",
  swimLiteral: "Natación",

  table_tennis: "table_tennis",
  table_tennisLiteral: "Tenis de mesa",

  tennis: "tennis",
  tennisLiteral: "Tenis",

  tennis_clay: "tennis_clay",
  tennis_grass: "tennis_grass",
  tennis_indoor: "tennis_indoor",

  volleyball: "volleyball",
  volleyballLiteral: "Voleibol",

  // Live Page Requirement
  videolive: "videolive",
  videoliveLiteral: "Video Live",
};
